import styled from 'styled-components';

export const ContainerChat = styled.div`
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
  position: absolute;
  z-index: 2;
  bottom: 0;
  left: 10%;
`;
